// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Ysa1V","text":"style_text__8gdx3","main":"style_main__zNi0m","secondary":"style_secondary__L1aZ+","contactUs":"style_contactUs__3kXnL"};